module.exports = __webpack_public_path__ + "img/P150T_weapon_83.7639678f.png";